// extracted by mini-css-extract-plugin
export default {"root":"ProjectNameForm_root__3q6ez"};